import Properties from '../components/properties/Properties.vue';
import Property from '../components/properties/Property.vue';
import PropertyCreate from '../components/forms/Property.vue';
import EditProperty from '../components/forms/edit/PropertyEdit.vue';
import Conformite from '../components/forms/Conformite.vue';
import Vpt from '../components/forms/Vpt.vue';
import Ve from '../components/forms/Ve.vue';
import EditConformite from '../components/forms/edit/ConformiteEdit.vue';
import EditVpt from '../components/forms/edit/VptEdit.vue';
import EditVe from '../components/forms/edit/VeEdit.vue';
import DetailConformite from '../components/controls/Conformite.vue';
import DetailVpt from '../components/controls/Vpt.vue';
import DetailVe from '../components/controls/Ve.vue';
import Home from '../components/home/Index.vue';
import Synthese from '../components/synthese/Synthese.vue';
import Controls from '../components/controls/Controls.vue';

import MailManagementIndex from '../components/MailManagement/Index.vue';

export default [
    { path: '/', name: 'properties', component: Properties },
    { path: '/index', name: 'home', component: Home },

    { path: '/properties/create', name: 'property_create', component: PropertyCreate },
    { path: '/properties/:propertyId/details', name: 'property_detail', component: Property },
    { path: '/properties/:propertyId/edit', name: 'property_edit', component: EditProperty },

    { path: '/properties/:propertyId/conformite/create', name: 'conformite_create', component: Conformite },
    { path: '/properties/:propertyId/conformite/:controlId/edit', name: 'conformite_edit', component: EditConformite },
    { path: '/properties/:propertyId/conformite/:controlId/detail', name: 'conformite_detail', component: DetailConformite },

    { path: '/properties/:propertyId/vpt/create', name: 'vpt_create', component: Vpt },
    { path: '/properties/:propertyId/vpt/:controlId/edit', name: 'vpt_edit', component: EditVpt },
    { path: '/properties/:propertyId/vpt/:controlId/detail', name: 'vpt_detail', component: DetailVpt },

    { path: '/properties/:propertyId/ve/create', name: 've_create', component: Ve },
    { path: '/properties/:propertyId/ve/:controlId/edit', name: 've_edit', component: EditVe },
    { path: '/properties/:propertyId/ve/:controlId/detail', name: 've_detail', component: DetailVe },

    { path: '/properties/:propertyId/:controlType/:controlId/mail-management', name: 'MailManagementIndex', component: MailManagementIndex },

    { path: '/synthese', name: 'synthese', component: Synthese },
    
    { path: '/controls', name: 'controls', component: Controls },
];
